import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmContext } from '../LawFirmContext';
import { LawFirmHeaderDecisionsLink } from './LawFirmHeaderDecisionsLink';
import { LawFirmFollow } from './follow/LawFirmFollow';
import {
  EntityHeaderPicture,
  EntityHeaderContainer,
  EntityHeaderTitleContainer,
  EntityHeaderTitle,
  EntityHeaderInfo,
  EntityHeaderImportant,
} from '../../../entity/components/EntityHeaderComponents';
import { getFormattedDate } from '../../../utils/date-utils/dateUtils';

export const LawFirmHeaderTop: FC = () => {
  const {
    lawFirmInfos: { name, dateRadiation },
  } = useContext(LawFirmContext);
  return (
    <EntityHeaderContainer>
      <EntityHeaderPicture imageUrl="/img/icons/entities/law-firm.svg" />
      <EntityHeaderTitleContainer>
        <EntityHeaderTitle>{name}</EntityHeaderTitle>
        <EntityHeaderInfo>
          <FormattedMessage id="law-firm/page/LawFirmHeaderTop.tsx/1" />
          {dateRadiation && (
            <EntityHeaderImportant>
              {' '}
              <FormattedMessage
                id="law-firm/page/LawFirmHeaderTop.tsx/2"
                values={{ date: getFormattedDate(dateRadiation) }}
              />
            </EntityHeaderImportant>
          )}
        </EntityHeaderInfo>
        <LawFirmHeaderDecisionsLink />
        <LawFirmFollow />
      </EntityHeaderTitleContainer>
    </EntityHeaderContainer>
  );
};
